module.exports = __webpack_public_path__ + "img/V7.64a628ac.png";